<template>
  <!-- Example usage:
    <autocompleteMultiLuRole
      v-model="selectedUser.UserRole" (the collection we are updating)
      selfKey="UserID" (how the selectedUser is referenced in the join item)
      :selfID="selectedUser.ID" (to create new entries we need the selected users ID)
      relatedItemKey="RoleID" (this is how the lookup is referenced in the join)
      joinItemName="UserRole" (this is the name of the join (for the js class))
    ></autocompleteMultiLuRole>
  -->
  <v-autocomplete
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :search-input.sync="lookupText"
    @change="lookupText = ''"
    :loading="loading"
    :placeholder="placeholder"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    cacheItems
    :rules="rules"
    chips
    deletable-chips
    multiple
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-autocomplete>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import Comment from '@classes/Comment'
import Document from '@classes/Document'
import Link from '@classes/Link'
import Notification from '@classes/Notification'
import TrackedBillAssignment from '@classes/TrackedBillAssignment'
import TrackedBill from '@classes/TrackedBill'
import TrackedBillUser from '@classes/TrackedBillUser'
import UserAgency from '@classes/UserAgency'
import UserRole from '@classes/UserRole'
export default {
  name: 'autocomplete-search-multi-join-users',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Users',
    },
    value: Array,
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Start typing to Search',
    },
    rules: Array,
    joinItemName: {
      type: String,
      required: true,
      //default: 'Comment',
      //default: 'Document',
      //default: 'Link',
      //default: 'Notification',
      //default: 'TrackedBillAssignment',
      //default: 'TrackedBill',
      //default: 'TrackedBill',
      //default: 'TrackedBillUser',
      //default: 'UserAgency',
      //default: 'UserRole',
    },
    relatedItemKey: {
      type: String,
      required: true,
      //default: 'UserID',
    },
    selfKey: {
      type: String,
      required: true,
    },
    selfID: {
      type: Number,
      required: true,
    },
    agencyID: {
      type: Number,
      required: false,
    },
    roles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      // itemText: 'FirstName',
      // itemText: 'LastName',
      itemText: 'Email',
    }
  },
  watch: {
    value(nval, oval) {
      if (nval != oval) {
        this.lookupText = ''
      }
    },
    lookupText(nval) {
      if (nval) {
        if (this.agencyID >= 0) {
          this.agencySearchID = this.agencyID
        } else {
          this.agencySearchID = null
        }
        if (this.roles && this.roles.length > 0) {
          this.agencySearchRoles = this.roles
        } else {
          this.agencySearchRoles = null
        }
      }
    },
    agencyID(nval, oval) {
      if (this.agencyID >= 0) {
        this.agencySearchID = this.agencyID
      } else {
        this.agencySearchID = null
      }
      if (this.roles && this.roles.length > 0) {
        this.agencySearchRoles = this.roles
      } else {
        this.agencySearchRoles = null
      }
      this.lookupText = ''
    },
    roles(nval, oval) {
      if (this.agencyID >= 0) {
        this.agencySearchID = this.agencyID
      } else {
        this.agencySearchID = null
      }
      if (this.roles && this.roles.length > 0) {
        this.agencySearchRoles = this.roles
      } else {
        this.agencySearchRoles = null
      }
      this.lookupText = ''
    },
  },
  computed: {
    ...get('user', ['users', 'loading']),
    ...sync('user', ['lookupText', 'agencySearchID', 'agencySearchRoles']),
    availableItems() {
      //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
      var list = this.users.filter((i) => true)
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value > 0) {
        var selectedItem = this.users.find((i) => i.ID == this.value)
        if (!list.find((i) => i.ID == this.value) && selectedItem) {
          list.push(selectedItem)
        }
      }
      // sort by column
      list.sort((a, b) => {
        //set the property to sort on
        let textField = this.itemText
        let sort = a[textField] > b[textField] ? 1 : -1
        return sort
      })
      return list
    },
    selected: {
      get() {
        if (this.value && this.value.length > 0) {
          return [
            ...new Set(this.value.map((item) => item[this.relatedItemKey])),
          ]
        } else {
          return []
        }
      },
      set(newValue) {
        if (this.value) {
          this.value.forEach((relation, index, object) => {
            if (!newValue.includes(relation[this.relatedItemKey])) {
              //need to remove item
              object.splice(index, 1)
            }
          })
          newValue.forEach((itemID) => {
            if (!this.value.find((i) => i[this.relatedItemKey] == itemID)) {
              // need to add item
              let item
              if (this.joinItemName == 'Comment') {
                item = new Comment()
              } else if (this.joinItemName == 'Document') {
                item = new Document()
              } else if (this.joinItemName == 'Link') {
                item = new Link()
              } else if (this.joinItemName == 'Notification') {
                item = new Notification()
              } else if (this.joinItemName == 'TrackedBillAssignment') {
                item = new TrackedBillAssignment()
              } else if (this.joinItemName == 'TrackedBill') {
                item = new TrackedBill()
              } else if (this.joinItemName == 'TrackedBill') {
                item = new TrackedBill()
              } else if (this.joinItemName == 'TrackedBillUser') {
                item = new TrackedBillUser()
              } else if (this.joinItemName == 'UserAgency') {
                item = new UserAgency()
              } else if (this.joinItemName == 'UserRole') {
                item = new UserRole()
              } else {
                item = {}
              }
              item[this.relatedItemKey] = itemID
              item[this.selfKey] = this.selfID
              this.value.push(item)
            }
          })
        }
      },
    },
  },
  created() {},
  methods: {},
}
</script>
<style>
</style>